export default __webpack_public_path__ + "static/media/india flag.6d3ac4b9.svg";